
import { trapFocus } from '../utils.js';
import 'core-js/es/array';

export default class Lightbox {

    constructor() {

        this.lightboxBtns = Array.from(document.querySelectorAll('[data-lightbox]'));
        this.lightboxCloseBtns = Array.from(document.querySelectorAll('.js-lightbox-close'));
        this.lightboxes = Array.from(document.querySelectorAll('.js-lightbox'));

        this.activeEl = null;

        if (!this.lightboxBtns) return;

        this.lightboxBtns.forEach(btn => btn.addEventListener('click', (ev) => {

            this.activeEl = document.activeElement;

            this.closeLightboxes();

            const id = btn.dataset.lightbox;
            const el = document.getElementById(id);

            el.classList.add('active');

            trapFocus(el);

        }));

        this.lightboxCloseBtns.forEach(btn => btn.addEventListener('click', (ev) => {

            this.closeLightboxes();

        }));

        document.addEventListener('keydown', (e) => {
            if(e.code == "Escape") this.closeLightboxes();
        });

    }

    closeLightboxes() {

        this.lightboxes.forEach(ligthbox => ligthbox.classList.remove('active'));

        this.activeEl.focus();

    }

}